require('../../../modules/es.function.bind');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Function').bind;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/function/virtual/bind.js
// module id = 489
// module chunks = 0 1